"use client";

import Link from "next/link";
import type { ComponentProps } from "react";
import {
  ANALYTICS_EVENTS,
  type AnalyticsMarketingCtaId,
  type AnalyticsMarketingPage,
} from "@bash/shared";
import { captureV1 } from "@/lib/analytics-v1";

/** marketing:cta_clicked (analytics v1) — a sign-up call to action was clicked. */
export function trackCtaClick(
  ctaId: AnalyticsMarketingCtaId,
  page: AnalyticsMarketingPage
): void {
  captureV1(ANALYTICS_EVENTS.MARKETING_CTA_CLICKED, { cta_id: ctaId, page });
}

type CtaLinkProps = ComponentProps<typeof Link> & {
  ctaId: AnalyticsMarketingCtaId;
  page: AnalyticsMarketingPage;
};

/**
 * A sign-up link on a marketing page that reports its click. It renders the
 * same next/link it replaces, so server-rendered pages keep their markup; the
 * click handler is the only thing it adds.
 */
export function CtaLink({ ctaId, page, onClick, ...props }: CtaLinkProps) {
  return (
    <Link
      {...props}
      onClick={(e) => {
        trackCtaClick(ctaId, page);
        onClick?.(e);
      }}
    />
  );
}
